<template>
  <div>
    <div class="loading" v-if="!productStore.reactionIsLoaded">
      در حال بارگذاری...
    </div>
    <div class="product-inner" v-else-if="productStore.reactionCards.length > 0">
      <ProductCardShablone v-for="product in productStore.reactionCards" :key="product.id" :card="product" :reaction="true" :edit="false" :showOne="false"/>
    </div>
    <div v-else class="none-cart-error">
      سفارشی ذخیره نکردید
    </div>
    <div ref="el" v-if="productStore.reactionHasMore"></div>
  </div>
</template>
<script setup>
  import { useTemplateRef } from 'vue'
  import { useInfiniteScroll } from '@vueuse/core'
  import { useProductStore } from '@/stores/product'
  import { useAlertStore } from '@/stores/alert'
  import ProductCardShablone from '@/components/dashboard/bodys/product/card/ProductCardShablone.vue'
  import { polling } from '@/composables/polling'
  import { isDefrentProductData } from '@/composables/polling/isDefrentProductData'
  const productStore = useProductStore()
  const alertStore = useAlertStore()
  const el = useTemplateRef('el')
  polling( 
    async () => await productStore.fetchProductReaction(productStore.reactionCards.length > 0 ? productStore.reactionCards.length : 10 , 0 , false),
    {
      oldData:productStore.reactionCards??[],
      intervalMs: 6000,
      isDifferent: (newData) => isDefrentProductData(productStore.reactionCards,newData),
      onChange: (allNewProduct) => {
        if(isDefrentProductData(productStore.reactionCards??[],allNewProduct??[])){
          if(productStore.reactionCards.length<allNewProduct.length){
            alertStore.type=true
            alertStore.msg='تغییرات جدید!'
          }
          productStore.reactionCards = allNewProduct??[]
        }
      }
    }
  )
  useInfiniteScroll(
    el, 
    async () => {
      await productStore.fetchProductReaction(10,productStore.reactionCards.length,true) 
    } , { 
      distance: 50,
      canLoadMore: () => { 
        return productStore.reactionHasMore
      } 
    }
  )
</script>
<style scoped>
    .product-inner {
        width: 100%;
        direction: rtl;
        height: 100%;
        display: flex;
        flex-direction: row-reverse;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: center;
        align-items: stretch;
    }
    .loading,.none-cart-error{
        text-align: center;
        padding: 20px;
        color: white;
        font-size: 20px;
        border-radius: 10px;
        box-shadow: 0 0 10px grey;
        font-weight: bold;
    }
    .loading{
        background: rgb(16, 16, 143);
    }
    .scroll-trigger {
        height: 1px;
    }
    .none-cart-error {
        background: rgb(128, 12, 12);
    }
</style>
